export const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const invalidChars = ['-', '+', 'e', 'E'];
  if (invalidChars.includes(event.key)) {
    event.preventDefault();
  }
};

export const handleWheel = (event: React.WheelEvent<HTMLInputElement>) => {
  event.currentTarget.blur(); // Elimina el foco del input para evitar cambios
  event.preventDefault(); // Previene el comportamiento predeterminado
};

// Rechaza números "falsos" cuya cola es toda el mismo dígito: 666666666, 65555555, 611111111…
// Devuelve true si el número es válido (no es un patrón repetido). El vacío se considera válido.
export const validNumberInput = (value: string): boolean => {
  return !/^\d(\d)\1+$/.test(value);
};

export const handleNumberKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>,
) => {
  const allowedControlKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Home',
    'End',
  ];
  if (allowedControlKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
    return;
  }
  if (!/[0-9/]/.test(e.key)) {
    e.preventDefault();
  }
};
